import { stopPropagation } from '../../../utils/events'
import { TagProgress } from '../TagProgress'
import { TagRemoveControl } from '../TagRemoveControl'

import * as styles from './TagActions.module.css'

function TagActions({
  afterContent,
  appearance,
  height,
  isDisabled,
  isFilled,
  qaName,
  removeHoverRef,
  removeTooltipKey,
  showProgress,
  showRemove,
  tooltipPlacement,
  onRemove,
}) {
  function handleRemove(e) {
    if (!isDisabled && onRemove) {
      stopPropagation(e)
      onRemove(e)
    }
  }

  return (
    <div className={styles.actions}>
      {showProgress ? <TagProgress /> : null}
      {afterContent}
      {showRemove ? (
        <TagRemoveControl
          appearance={appearance}
          height={height}
          qaName={qaName}
          ref={isFilled ? removeHoverRef : undefined}
          tooltipKey={removeTooltipKey}
          tooltipPlacement={tooltipPlacement}
          onClick={handleRemove}
        />
      ) : null}
    </div>
  )
}

export default TagActions
